import { InjectionToken } from '@angular/core';
import { TenantOrganisationDataService } from '../repositories/tenant-organisation-data.service';

export const TENANT_ORGANISATION_DATA_SERVICE =
  new InjectionToken<TenantOrganisationDataService>(
    'TENANT_ORGANISATION_DATA_SERVICE'
  );
